import { graphql } from "@server/gql";

export default graphql(/* GraphQL */ `
  query EditorialPageBySlug(
    $locale: String
    $slug: String!
    $limit: Int!
    $preview: Boolean
    $activeMarkets: [String]
  ) {
    editorialPageCollection(
      locale: $locale
      where: { slug: $slug }
      limit: $limit
      preview: $preview
    ) {
      items {
        ...editorialPage
      }
    }
  }
`);
